import React, { useEffect, useMemo, useState } from "react";
import { Box, Button, Stack } from "@mui/material";
import { BodyContainer, Header, HeaderTitle } from "../bank/styles";
import Loader from "../../components/components/Loader";
import DataTable from "react-data-table-component";
import Repo from "../../Repository/Repo";
import SearchField from "../../components/components/Search";
import Barcode from "react-barcode";
import BarcodesPrint from "./BarcodesPrint";
import Customization from "./Customization";
import { Toast } from "../../components/components/Toast";

function BarcodePrints() {
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [toggledClearRows, setToggleClearRows] = useState(false);
  const [selected, setSelected] = useState([]);
  const [open, setOpen] = useState(false);
  const [customModal, setCustomModal] = useState(false);
  const [items, setItems] = useState([]);

  const columns = [
    {
      name: "Item",
      selector: (row) => row?.name,
    },

    {
      name: "Barcode",
      selector: (row) => (
        <Barcode height={50} fontSize={15} value={row?.barCode} />
      ),
    },
  ];

  useEffect(() => {
    getItems();
  }, []);

  const getItems = async () => {
    try {
      setLoading(true);
      let { data } = await Repo.default({
        request: {
          method: "getBarCodeItemsByCompany",
          data: {
            company_code: localStorage.getItem("companyCode"),
          },
        },
      });
      setLoading(false);
      if (data.response.status.statusCode == 200) {
        if (data.response.data.itemsArr) {
          setItems(data.response.data.itemsArr);
        } else {
          setItems([]);
        }
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const customToggle = () => {
    setCustomModal((prev) => !prev);
  };
  const printToggle = () => {
    if (selected.length == 0) {
      Toast("info", "Kindly select items");
      return;
    }
    setOpen((prev) => !prev);
  };

  const rowSelection = (data) => {
    setSelected(data.selectedRows);
  };

  const handleInput = (e) => {
    const { value } = e.target;
    setSearchText(value);
  };

  const subHeaderComponentMemo = () => {
    return (
      <Box
        sx={{ width: "100%", display: "flex", justifyContent: "space-between" }}
      >
        <Button
          variant="contained"
          sx={{ textTransform: "none", mr: "8px" }}
          onClick={customToggle}
        >
          Customize
        </Button>
        <Stack direction="row">
          <Button
            variant="contained"
            sx={{ textTransform: "none", mr: "8px" }}
            onClick={printToggle}
          >
            Print
          </Button>
          <SearchField
            text="search barCode..."
            name="searchText"
            sx={{
              ml: "8px",
              background: "#fff !important",
              borderRadius: "8px",
            }}
            value={searchText}
            onChange={handleInput}
          />
        </Stack>
      </Box>
    );
  };
  const filtered = useMemo(() => {
    if (searchText) {
      return items.filter((i) => {
        return i?.name
          .toString()
          .toLowerCase()
          .startsWith(searchText.toLowerCase());
      });
    } else {
      return items;
    }
  }, [searchText, items]);

  const onSuccess = () => {
    printToggle();
    setSelected([]);
    setToggleClearRows(true);
  };

  return (
    <Box>
      <Header>
        <HeaderTitle> </HeaderTitle>
        <HeaderTitle>Barcodes</HeaderTitle>
        <HeaderTitle> </HeaderTitle>
      </Header>
      <BodyContainer>
        {!loading && (
          <DataTable
            columns={columns}
            data={filtered}
            pagination
            subHeader
            subHeaderComponent={subHeaderComponentMemo()}
            selectableRows
            onSelectedRowsChange={rowSelection}
            clearSelectedRows={toggledClearRows}
          />
        )}
        {loading && <Loader loading={true} />}

        {open && (
          <BarcodesPrint
            items={selected}
            onClose={printToggle}
            onSuccess={onSuccess}
          />
        )}
        {customModal && <Customization onClose={customToggle} />}
      </BodyContainer>
    </Box>
  );
}

export default BarcodePrints;
